export const UPDATE_SALES_BY_STORE_WIDGET = "UPDATE_SALES_BY_STORE_WIDGET";